import { render, staticRenderFns } from "./EditaCliente.vue?vue&type=template&id=7ac7c4b6&"
import script from "./EditaCliente.vue?vue&type=script&lang=js&"
export * from "./EditaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports